import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

/**
 * isDisplayTelephoneViewInQAList
 * Check condition display telephone view in QA list
 * Display only when:
 * - User is B2C
 * - Project in use is Customer type
 * - Setting Telephone Agent is enable in org
 * @param {*} userDetail 
 * @param {*} projectInuseDetail 
 * @param {*} corporationDetail 
 * @returns Boolean
 */
export const isDisplayTelephoneViewInQAList = (
    userDetail,
    projectInuseDetail,
    corporationDetail
) => {
    if (
        Utils.isEmptyObject(userDetail) ||
        Utils.isEmptyObject(projectInuseDetail) ||
        Utils.isEmptyObject(corporationDetail)
    ) {
        return false;
    }

    const isDisplayHelpdesk = Utils.isDisplayHelpdeskTicketList(projectInuseDetail);
    if (isDisplayHelpdesk) return false;

    return Utils.isEnableSettingTelephoneAgent(corporationDetail);
};
